module.exports = __webpack_public_path__ + "static/media/academic-large--resized.af117f9e.jpg";